const payment_statuses = {
  pending: {
    label: 'Pending',
    value: 'P',
  },
  canceled: {
    label: 'Canceled',
    value: 'X',
  },
  withdrawn: {
    label: 'Withdrawn',
    value: 'W',
  },
  error: {
    label: 'Error',
    value: 'E',
  },
  rejected: {
    label: 'Rejected',
    value: 'R',
  },
  completed: {
    label: 'Completed',
    value: 'C',
  },
};

export default {
  payment_statuses,
};



// WEBPACK FOOTER //
// ./src/app/main/payments/constants/payment-constants.js